import { ReactNode } from 'react';
import {
  FallbackProps,
  ErrorBoundary as ReactErrorBoundary,
} from 'react-error-boundary';

export function ErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <ReactErrorBoundary FallbackComponent={FallbackComponent}>
      {children}
    </ReactErrorBoundary>
  );
}

function FallbackComponent({ error }: FallbackProps) {
  const message =
    error instanceof Error ? (error.stack ?? error.message) : String(error);

  return (
    <div>
      <h1>Something went wrong</h1>
      <p>The Bot Academy encountered an error and couldn't load properly.</p>
      <pre style={{ color: '#900' }}>{message}</pre>
    </div>
  );
}
